export default __webpack_public_path__ + "static/media/p41.b71abade.jpg";